import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IForgetResendPinRequest, IForgetResendPinResponse } from '../../../entity/interface/iAuthApis';

export interface IForgetResendPinUseCase {
    execute(payload: IForgetResendPinRequest, apiToken?: { [key: string]: string }): Promise<IForgetResendPinResponse>;
}

export class ForgetResendPinUseCase implements IForgetResendPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IForgetResendPinRequest,
        apiToken: { [key: string]: string }
    ): Promise<IForgetResendPinResponse> {
        return await this.authRepo.forgetResendPin(payload, apiToken);
    }
}
